import React from "react";
import { Alert } from "@mui/material";
import AppModal from "../common/AppModal";
import CreateOrUpdateTaxCodeForm from "../../forms/CreateOrUpdateTaxCodeForm";

const UpdateTaxCodeModal = ({ open, onClose, taxCode, loading, error }) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit Tax Code: ${taxCode.name}`}
    width="sm"
    loading={loading}
  >
    {error && (
      <Alert severity="error" sx={{ mb: 2 }}>
        {error}
      </Alert>
    )}
    <CreateOrUpdateTaxCodeForm
      isEditing={true}
      taxCode={taxCode}
      loading={loading}
    />
  </AppModal>
);

export default UpdateTaxCodeModal;
